"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _SvgImage = _interopRequireDefault(require("@healthwise-ui/core/SvgImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  padding: 14px 24px 24px;\n  text-align: center;\n  background-color: ", ";\n\n  & h3 {\n    margin-top: 23px;\n    margin-left: 65px;\n    font-size: 2em;\n    line-height: 1em;\n    font-weight: normal;\n    color: ", ";\n  }\n\n  & img,\n  & svg {\n    position: absolute;\n    top: 27px;\n    max-width: 48px !important;\n    max-height: 48px;\n  }\n\n  & p {\n    font-size: 1em;\n    line-height: 1.33;\n    color: ", ";\n  }\n\n  & button {\n    margin-right: 0.5em;\n    margin-bottom: 0.5em;\n    font-size: 1.5em;\n    border-radius: 0.25em;\n    border-color: transparent;\n    color: ", ";\n    background: ", ";\n  }\n\n  & button:hover {\n    color: ", ";\n    background: ", ";\n  }\n\n  @media screen and (max-width: 750px) {\n    & h3 {\n      margin-top: 26px;\n    }\n  }\n\n  @media print {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 0.75em;\n  text-align: left;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextWrapperDiv = _styledComponents.default.div(_templateObject());

var WrapperSection = _styledComponents.default.section(_templateObject2(), function (props) {
  return props.theme.colorBackground;
}, function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.colorTextOnPrimary;
}, function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return props.theme.colorTextOnPrimaryLight;
}, function (props) {
  return props.theme.colorPrimaryLight;
});

var CallToAction = /*#__PURE__*/function (_Component) {
  _inherits(CallToAction, _Component);

  var _super = _createSuper(CallToAction);

  function CallToAction(props) {
    var _this;

    _classCallCheck(this, CallToAction);

    _this = _super.call(this, props);
    _this.renderHtmlParts = _this.renderHtmlParts.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CallToAction, [{
    key: "parseHtml",
    value: function parseHtml() {
      var elements = {};

      if (this.props.item && this.props.item.html) {
        var parser = new window.DOMParser();
        var doc = parser.parseFromString(this.props.item.html, 'text/html'); // TODO: temporary logic until we get one consistent format

        var title = doc.querySelector('h3') || doc.querySelector('head title');
        var img = doc.querySelector('img');
        var paragraphs = doc.querySelectorAll('p');

        if (title) {
          elements['title'] = /*#__PURE__*/_react.default.createElement("h3", null, title.innerHTML);
        }

        if (img) {
          elements['img'] = /*#__PURE__*/_react.default.createElement(_SvgImage.default, {
            src: img.getAttribute('src')
          });
        }

        if (paragraphs) {
          elements.paragraphs = [];

          for (var i = 0; i < paragraphs.length; i++) {
            var newArray = elements.paragraphs;
            newArray.push( /*#__PURE__*/_react.default.createElement("p", {
              key: 'cta_para_' + newArray.length
            }, paragraphs[i].innerHTML));
          }
        }
      }

      return elements;
    }
  }, {
    key: "renderHtmlParts",
    value: function renderHtmlParts() {
      var elements = this.parseHtml();
      return /*#__PURE__*/_react.default.createElement(TextWrapperDiv, null, elements.title, elements.img, elements.paragraphs);
    }
  }, {
    key: "render",
    value: function render() {
      var renderHtmlParts = this.renderHtmlParts;
      var wrapperClasses = (0, _classnames.default)({
        'hw-call-to-action': true
      });
      return /*#__PURE__*/_react.default.createElement(WrapperSection, {
        className: wrapperClasses
      }, renderHtmlParts(), this.props.actionButtons);
    }
  }]);

  return CallToAction;
}(_react.Component);

CallToAction.propTypes = {
  item: _propTypes.default.object,
  actionButtons: _propTypes.default.node
}; // CallToAction.defaultProps = {
//   theme: defaultTheme,
// }

var _default = (0, _styledComponents.withTheme)(CallToAction);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/CallToAction/index.js